export default __webpack_public_path__ + "static/media/avicii.e34cdc69.jpg";